import { render, staticRenderFns } from "./GatewayRulesSettings.vue?vue&type=template&id=63ee023e"
import script from "./GatewayRulesSettings.vue?vue&type=script&lang=js"
export * from "./GatewayRulesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports